//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WxjsSdk from "@/Manager/10.Tms/ProductSnManager";
import areaList from "@/0/Utils/AreaUtils.js";
export default {
  components: { WxjsSdk },
  props: ["information", "ConfigUrl"],
  data() {
    return {
      areaList,
      AddressShow: false
    };
  },
  async created() {},
  async mounted() {
    await this.wxJsSdk();
  },
  methods: {
    Confirm(res) {
      console.log(res, "数据");
      var totalAddress = "";
      var province = "";
      var City = "";
      var District = "";
      res.map((item, index) => {
        totalAddress = totalAddress + item.name;
        if (index == 0) {
          province = item.name;
        } else if (index == 1) {
          City = item.name;
        } else if (index == 2) {
          District = item.name;
        }
      });
      this.information.totalAddress = totalAddress;
      this.information.province = province;
      this.information.City = City;
      this.information.District = District;
      this.Cancel();
    },
    Cancel() {
      this.AddressShow = false;
    },
    async delAddress() {
      console.log("删除收货地址");
      var postData = { openId: this.information.OpenId };
      let { data: result } = await this.$http({
        method: "post",
        url: this.ConfigUrl.Delete,
        data: postData
      });
      if (result.state == 1) {
        this.Close();
        this.$emit("GetAddressList");
        return;
      }
      this.$msg.alert(result.msg);
    },
    async Save() {
      if (this.information.type == 0) {
        let res = await this.postDefaultInterface(this.ConfigUrl.Create);
        console.log(res, "添加返回数据");
        if (res.state == 1) {
          this.Close();
          this.$emit("GetAddressList");
          return;
        }
        this.$msg.alert(res.msg);
      } else if (this.information.type == 1) {
        let res = await this.postDefaultInterface(
          this.ConfigUrl.Edit,
          this.information.OpenId
        );
        console.log(res, "修改返回数据");
        if (res.state == 1) {
          this.Close();
          this.$emit("GetAddressList");
          return;
        }
        this.$msg.alert(res.msg);
      }
    },
    async postDefaultInterface(Url, OpenId) {
      var information = this.information;
      var postData = {
        SourceWay: 1,
        Contact: information.userName, //联系人
        Mobile: information.telNumber, //手机号
        Province: information.province, //省
        City: information.City, //市
        District: information.District, //区
        Address: information.DetailedAddress, //详细地址
        FullAddress: information.totalAddress + information.DetailedAddress //完整地址
      };
      if (OpenId) {
        postData.OpenId = OpenId;
      }
      this.$msg.showLoading();
      let { data: result } = await this.$http({
        method: "post",
        url: Url,
        data: postData
      });
      this.$msg.hideLoading();
      return result;
    },
    Close() {
      this.$emit("close");
    },
    Choice() {
      this.AddressShow = true;
    },
    openAddress() {
      var that = this;
      wx.openAddress({
        success: function(res) {
          var userName = res.userName; // 收货人姓名
          var postalCode = res.postalCode; // 邮编
          var provinceName = res.provinceName; // 国标收货地址第一级地址（省）
          var cityName = res.cityName; // 国标收货地址第二级地址（市）
          var countryName = res.countryName; // 国标收货地址第三级地址（国家）
          var detailInfo = res.detailInfo; // 详细收货地址信息
          var nationalCode = res.nationalCode; // 收货地址国家码
          var telNumber = res.telNumber; // 收货人手机号码
          var ReceivingGoods = {
            userName: userName,
            telNumber: telNumber,
            detailInfo: provinceName + cityName + countryName + detailInfo
          };
          that.ReceivingGoods = ReceivingGoods;
        },
        cancel: function(errMsg) {
          // 用户取消拉出地址 //
          // alert(errMsg);
        }
      });
    },
    wxJsSdk() {
      this.$msg.showLoading();
      var wxUrl = window.location.href.split("#")[0];
      var sdkData = {
        uOpenId: "8659662804444e4b9ff929bb78b3da21",
        url: wxUrl
      };
      WxjsSdk.wxJsSdk(sdkData).then(res => {
        this.$msg.hideLoading();
        wx.config({
          debug: false, // true,// 开启调试模式
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          // 必填，需要使用的JS接口列表
          jsApiList: ["openAddress"]
        });
      });
    },
    alertObj(obj) {
      var output = "";
      for (var i in obj) {
        var property = obj[i];
        output += i + " = " + property + "\n";
      }
      alert(output);
    }
  }
};
